import { AgentGatewayMessage } from '../../types/AgentMessage';
import { GetAgentsParams } from '../common/api/clients/gateway.api';
import { queries } from '../common/api/queryKeys/queries';
import { usePaginationQuery } from '../common/hooks/usePaginationQuery';

export const useAgentPagination = ({ portIds, customerIds, searchQuery, page, active }: GetAgentsParams) => {
    const nextPage = queries.agents.pagination({ page: page + 1, portIds, customerIds, searchQuery, active });

    return usePaginationQuery<AgentGatewayMessage>({
        ...queries.agents.pagination({ portIds, customerIds, searchQuery, page, active }),
        prefetchQueryKey: nextPage.queryKey,
        prefetchQueryFn: nextPage.queryFn,
    });
};
